package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.String

public class BrandQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> all(mapper: (
    id: String,
    name: String,
    logoUri: String?,
  ) -> T): Query<T> = Query(1_229_403_315, arrayOf("BrandEntity"), driver, "Brand.sq", "all",
      "SELECT BrandEntity.id, BrandEntity.name, BrandEntity.logoUri FROM BrandEntity") { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)
    )
  }

  public fun all(): Query<BrandEntity> = all { id, name, logoUri ->
    BrandEntity(
      id,
      name,
      logoUri
    )
  }
}
